import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeOpenPriceMaxThreshold: (value: Nullable<number>) => void;
}

export const OpenPriceMaxThresholdInput: React.FC<IProps> = React.memo(({ changeOpenPriceMaxThreshold }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(
		() => [{ type: 'number', min: 1, message: t('openPriceMaxThresholdIsTooSmall') }],
		[t],
	);

	return (
		<FormInput
			testId="OpenPriceMaxThresholdInput"
			name="openPriceMaxThreshold"
			label="openPriceMaxThresholdLabel"
			placeholder="openPriceMaxThresholdPlaceholder"
			min={0}
			precision={0}
			onChangeNumber={changeOpenPriceMaxThreshold}
			validationRules={validationRules}
			type="number"
		/>
	);
});
